import { Delete, Edit } from "@mui/icons-material";
import {
  TableRow,
  TableCell,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { useModal } from "@refinedev/core";
import { PriceSettingDeleteDialog } from "./PriceSettingDeleteDialog";
import { PricingRule } from "../../PricingSettings";
import React from "react";

type ReadonlySettingRowProps = {
  rule: PricingRule;
  onEditStart: () => void;
  showEdit: boolean;
  rulesUrl: string;
  customHeader?: React.ReactNode;
  deletable?: boolean;
  backgroundColor?: string;
};

export const ReadonlySettingRow = (props: ReadonlySettingRowProps) => {
  const {
    customHeader,
    rule,
    onEditStart,
    showEdit,
    deletable,
    rulesUrl,
    backgroundColor,
  } = props;
  const { close, show, visible } = useModal();

  return (
    <TableRow
      sx={{
        height: "75px",
        backgroundColor: backgroundColor,
      }}
    >
      <TableCell scope="row" align="center" width="250px">
        {customHeader ?? (
          <Typography fontWeight="bold">
            $ {rule.lowerBound ?? "~"} - $ {rule.upperBound ?? "~"}
          </Typography>
        )}
      </TableCell>
      <TableCell align="center">
        <Typography>%{rule.minProfitPercentage}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography>%{rule.standardProfitPercentage}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography>%{rule.maxProfitPercentage}</Typography>
      </TableCell>
      <TableCell align="center">
        <Box display="flex" justifyContent="center">
          <IconButton
            onClick={onEditStart}
            disabled={!showEdit}
            color="primary"
            size="small"
          >
            <Edit />
          </IconButton>
          {deletable && (
            <IconButton
              onClick={show}
              disabled={!showEdit}
              color="error"
              size="small"
            >
              <Delete />
            </IconButton>
          )}
        </Box>
      </TableCell>
      <PriceSettingDeleteDialog
        open={visible}
        handleClose={close}
        rulesUrl={rulesUrl}
      />
    </TableRow>
  );
};
